import * as path from 'path';
import { toPairs, fromPairs } from 'lodash';

type Paths = { [alias: string]: string[] };
type ModuleNameMapper = { [alias: string]: string };

// tsconfig -> jest
export const pathsToModuleNameMapper = (
  paths: Paths,
  pathPrefix: string,
): ModuleNameMapper =>
  fromPairs(
    toPairs(paths).map(([alias, mappedPaths]) => [
      `^${alias}$`,
      path.resolve(pathPrefix, mappedPaths[0]),
    ]),
  );

// jest -> webpack/craco
export const moduleNameMapperToAlias = (
  moduleNameMapper: ModuleNameMapper,
  pathPrefix: string,
  stripPrefix: string,
) => {
  return fromPairs(
    toPairs(moduleNameMapper).map(([moduleName, mappedPath]) => [
      moduleName.slice(1, -1),
      path.resolve(pathPrefix, mappedPath.slice(stripPrefix.length)),
    ]),
  );
};

// tsconfig -> webpack/craco
// Haven't had a use case for this yet, but if we need to perform this transformation we could easily write
// a transformation function as seen above. Another option is to try out the tsconfig-paths-webpack-plugin.
// https://github.com/dividab/tsconfig-paths-webpack-plugin

export const noop = () => {};
